import { TranslateFn } from '../../I18N/types';
import { ErrorWithData } from '../types';

const DEFAULT_MAX_COUNT = 6;

const getAttemptErrorMessage = (t: TranslateFn, e: ErrorWithData, useEmailOnlyAuthError: boolean): string => {
  const isAccountNotFound = e?.data?.name === 'accountNotFoundError';
  const attemptTry = e?.data?.errorData?.data?.errorData?.loginAttemptCount;

  // if account is locked, return that message
  const isLocked = e?.data?.errorData?.data?.errorCode === 27;
  if (isLocked) {
    return t('common:globalError.accountLocked');
  }

  // if the account was not found, display the default message,
  // or show attempts left if they are running out of chances
  if (isAccountNotFound) {
    if (useEmailOnlyAuthError) {
      return t('common:globalError.accountNotFoundErrorEmailOnlyAuth');
    }
    return t('common:globalError.accountNotFoundError');
  }

  // if they are running out of attempts, tell them how many
  // chances they have left
  if (attemptTry > 2) {
    return t('common:globalError.attemptsLeftError', { attempts: DEFAULT_MAX_COUNT - attemptTry });
  }

  // fallback to the default user not found error
  return t('common:globalError.defaultAttemptError');
};

export default getAttemptErrorMessage;
